<template>
  <v-app id="inspire" class="gris">
    <v-navigation-drawer
      class="d-print-none"
      v-model="drawer"
      app
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <v-list nav>
        <v-list-item
          v-for="m in modulosUsuario"
          :key="m.ModuloID"
          :disabled="m.Inactivo"
          :to="m.Router"
          link
          active-class="primary white--text"
          class="py-1 mx-1"
        >
          <v-list-item-icon class="my-2 align-self-center">
            <v-icon>{{ m.Icono }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ m.Modulo }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      class="v-bar--underline d-print-none"
      color="gris"
      height="70"
      flat
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <img
        src="../assets/digitrack.png"
        style="height: 40px; width: auto;"
        class="mx-5"
      />
      <v-toolbar-title class="font-weight-light text-h5">
        {{ $route.name }}
      </v-toolbar-title>

      <v-spacer />
      <v-avatar size="35" color="secondary">
        <span class="white--text"> </span>
      </v-avatar>
      <span class="ml-3">
        {{ nombre }}
      </span>
      <v-btn icon @click.prevent="salir">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container class="fill-height" fluid grid-list-md>
        <v-layout row>
          <v-flex xs12 ml-5 mr-5 mb-6>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Modulos from '../services/modulos';
export default {
  name: 'Principal',
  data: function() {
    return {
      drawer: false,
      modulos: Modulos,
    };
  },
  computed: {
    nombre() {
      return localStorage.getItem('nombre');
    },
    modulosUsuario() {
      let permisos = localStorage.getItem('modulos');
      if (!permisos) return [];
      permisos = JSON.parse(permisos);
      return this.modulos.filter((m) => permisos.indexOf(m.ModuloID) > -1);
    },
  },
  methods: {
    salir() {
      this.confirmar('Salir del sistema', 'Desea salir del sistema?').then(
        () => {
          this.$router.replace('/');
        }
      );
    },
  },
};
</script>

<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';

@media #{map-get($display-breakpoints, 'print-only')} {
  .flex,
  .row,
  .v-input,
  .v-input--selection-controls,
  .v-input__slot,
  .p-1,
  .p-2,
  .p-3,
  .p-4,
  .p-5,
  .m-1,
  .m-2,
  .m-3,
  .m-4,
  .m-5,
  .v-card__title {
    font-size: 8px !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .v-application .text-h5,
  .v-application .text-h4,
  input,
  label,
  .v-icon.v-icon {
    font-size: 12px !important;
    line-height: 12px !important;
  }
  .v-card,
  .v-card-text {
    border: none !important;
    box-shadow: none !important;
  }
  .v-messages {
    display: none !important;
  }
  header {
    display: none;
  }
  .v-main {
    padding: 0 !important;
  }
}
</style>
